export default "__VITE_ASSET__CA_$RUv4__"